import { render, staticRenderFns } from "./threeScreenLive.vue?vue&type=template&id=3b7d4a00&scoped=true&"
import script from "./threeScreenLive.vue?vue&type=script&lang=js&"
export * from "./threeScreenLive.vue?vue&type=script&lang=js&"
import style0 from "./threeScreenLive.vue?vue&type=style&index=0&id=3b7d4a00&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b7d4a00",
  null
  
)

export default component.exports